module.exports = __webpack_public_path__ + "static/media/train tickets.576fcf43.png";